!function (e) {
    "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? module.exports = e() : window.wNumb = e()
}(function () {
    "use strict";
    var o = ["decimals", "thousand", "mark", "prefix", "suffix", "encoder", "decoder", "negativeBefore", "negative", "edit", "undo"];

    function w(e) {
        return e.split("").reverse().join("")
    }

    function h(e, t) {
        return e.substring(0, t.length) === t
    }

    function f(e, t, n) {
        if ((e[t] || e[n]) && e[t] === e[n]) throw new Error(t)
    }

    function x(e) {
        return "number" == typeof e && isFinite(e)
    }

    function n(e, t, n, r, i, o, f, u, s, c, a, p) {
        var d, l, h, g = p, v = "", m = "";
        return o && (p = o(p)), !!x(p) && (!1 !== e && 0 === parseFloat(p.toFixed(e)) && (p = 0), p < 0 && (d = !0, p = Math.abs(p)), !1 !== e && (p = function (e, t) {
            return e = e.toString().split("e"), (+((e = (e = Math.round(+(e[0] + "e" + (e[1] ? +e[1] + t : t)))).toString().split("e"))[0] + "e" + (e[1] ? e[1] - t : -t))).toFixed(t)
        }(p, e)), -1 !== (p = p.toString()).indexOf(".") ? (h = (l = p.split("."))[0], n && (v = n + l[1])) : h = p, t && (h = w((h = w(h).match(/.{1,3}/g)).join(w(t)))), d && u && (m += u), r && (m += r), d && s && (m += s), m += h, m += v, i && (m += i), c && (m = c(m, g)), m)
    }

    function r(e, t, n, r, i, o, f, u, s, c, a, p) {
        var d, l = "";
        return a && (p = a(p)), !(!p || "string" != typeof p) && (u && h(p, u) && (p = p.replace(u, ""), d = !0), r && h(p, r) && (p = p.replace(r, "")), s && h(p, s) && (p = p.replace(s, ""), d = !0), i && function (e, t) {
            return e.slice(-1 * t.length) === t
        }(p, i) && (p = p.slice(0, -1 * i.length)), t && (p = p.split(t).join("")), n && (p = p.replace(n, ".")), d && (l += "-"), "" !== (l = (l += p).replace(/[^0-9\.\-.]/g, "")) && (l = Number(l), f && (l = f(l)), !!x(l) && l))
    }

    function i(e, t, n) {
        var r, i = [];
        for (r = 0; r < o.length; r += 1) i.push(e[o[r]]);
        return i.push(n), t.apply("", i)
    }

    return function e(t) {
        if (!(this instanceof e)) return new e(t);
        "object" == typeof t && (t = function (e) {
            var t, n, r, i = {};
            for (void 0 === e.suffix && (e.suffix = e.postfix), t = 0; t < o.length; t += 1) if (void 0 === (r = e[n = o[t]])) "negative" !== n || i.negativeBefore ? "mark" === n && "." !== i.thousand ? i[n] = "." : i[n] = !1 : i[n] = "-"; else if ("decimals" === n) {
                if (!(0 <= r && r < 8)) throw new Error(n);
                i[n] = r
            } else if ("encoder" === n || "decoder" === n || "edit" === n || "undo" === n) {
                if ("function" != typeof r) throw new Error(n);
                i[n] = r
            } else {
                if ("string" != typeof r) throw new Error(n);
                i[n] = r
            }
            return f(i, "mark", "thousand"), f(i, "prefix", "negative"), f(i, "prefix", "negativeBefore"), i
        }(t), this.to = function (e) {
            return i(t, n, e)
        }, this.from = function (e) {
            return i(t, r, e)
        })
    }
});